<template>
<div class="w-full bg-gray-200 pt-3">
  <div class=" py-3 flex justify-center">
    <div v-for="(item, index) in filteredFlowItem" :key="index" :class="isClass(index)">
      <i></i>
      <abbr></abbr>

      <span class="inline-block pt-3 name-label text-xs sm:text-xs md:text-sm">{{ item.name }}</span>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ["index"],
  data() {
    return {
      isInterState: true,
      filteredFlowItem: [],
      flowItem: [
        {
          index: 1,
          name: "Dispatched",
        },
        {
          index: 2,
          name: "Hand-off Processed",
        },
        {
          index: 3,
          name: "Consolidated",
        },
        {
          index: 4,
          name:  "In transit",
        },
        {
          index: 5,
          name: "Arrived",
        },
        {
          index: 6,
          name: "Enroute to Customer",
        },
        {
          index: 7,
          name: "ETA",
        },
      ],
    };
  },
  computed: {
    routeId() {
      return this.index - 1;
    },
    shipping(){
      return  this.$store.getters.getBookingStates
    }
  },
  activated() {
    this.filteredFlowItem = this.flowItem
  },
  mounted(){
    this.filteredFlowItem = this.flowItem
  },
  watch: { 
    // "$store.getters.getBookingStates"(val){
    //   const shippingMethod = `${this.$store.getters.getBookingShippingMethod[0]}-to-${this.$store.getters.getBookingShippingMethod[1]}`;
    //   const checktype = (val.reciever === val.sender) && (shippingMethod !== "terminal-to-terminal")
    //   this.filteredFlowItem = this.flowItem
    //   checktype ? this.filteredFlowItem = this.flowItem.filter((item)=> item.name !== "Services") : this.filteredFlowItem = this.flowItem
    // }
  },
  methods: {
    isClass(val) {
      let classes;
      if (Number(this.routeId) > val) {
        classes = "pass-flow-item ";
      } else if (Number(this.routeId) == val) {
        classes = "active-flow-item";
      } else if (Number(this.routeId) < val) {
        classes = "flow-item";
      }

      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
.name-label {
  position: relative;
  left: -25px;
}

.flow-item {
  border-top: 3px dashed #878a8d;
  width: 18%;
  position: relative;
  i {
    position: absolute;
    display: inline-block;
    width: 50%;
    height: 12px;
    top: -6.5px;
    border-radius: 50px;
    @apply bg-transparent;
  }
  abbr {
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 3px;
    top: -3px;
    border-radius: 50px;
    @apply bg-transparent;
  }
  &::after {
    content: "";
    position: absolute;
    display: block;
    left: 0px;
    border-radius: 50%;
    border: 2px solid #878a8d;
    top: calc(0% - 12px);
    height: 20px;
    width: 20px;
    background: white;
    transition: 300ms;
  }
  &::before {
    content: "";
    position: absolute;
    display: block;
    left: 5px;
    z-index: 2;
    border-radius: 50%;
    border: 1.5px solid #c8ccd0;
    top: calc(0% - 7px);
    height: 10px;
    width: 10px;
    background: white;
    transition: 300ms;
  }
}
.active-flow-item {
  border-top: 3px dashed #878a8d;
  width: 18%;
  position: relative;
  i {
    position: absolute;
    display: inline-block;
    width: 50%;
    height: 12px;
    top: -7.5px;
    border-radius: 50px;
    @apply bg-primary-yellow;
    transition: 300ms;
  }
  abbr {
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 3px;
    top: -3px;
    border-radius: 50px;
    @apply bg-transparent;
    transition: 300ms;
  }
  &::after {
    content: "";
    position: absolute;
    display: block;
    left: -5px;
    border-radius: 50%;
    border: 2px solid #fcc210;
    top: calc(0% - 17px);
    height: 30px;
    width: 30px;
    @apply bg-primary-yellow;
    transition: 300ms;
  }
  &::before {
    content: "";
    position: absolute;
    display: block;
    left: 0px;
    z-index: 2;
    border-radius: 50%;
    border: 1.5px solid transparent;
    top: calc(0% - 12px);
    height: 20px;
    width: 20px;
    background: white;
    transition: 300ms;
  }
}

.pass-flow-item {
  border-top: 3px dashed #878a8d;
  width: 18%;
  position: relative;
  i {
    position: absolute;
    display: inline-block;
    width: 50%;
    height: 12px;
    top: -6.5px;
    border-radius: 50px;
    @apply bg-transparent;
    transition: 300ms;
  }
  abbr {
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 3px;
    top: -3px;
    border-radius: 50px;
    @apply bg-primary-yellow;
    transition: 300ms;
  }
  &::after {
    content: "";
    position: absolute;
    display: block;
    left: 0px;
    border-radius: 50%;
    border: 2px solid #FCC210;
    top: calc(0% - 12px);
    height: 20px;
    width: 20px;
    @apply  bg-primary-yellow;
    transition: 300ms;
  }
  &::before {
    content: "";
    position: absolute;
    display: block;
    left: 5px;
    z-index: 2;
    border-radius: 50%;
    border: 1.5px solid transparent;
    top: calc(0% - 7px);
    height: 10px;
    width: 10px;
    background: white;
    transition: 300ms;
  }
}

.flow-item:nth-last-child(1),
.active-flow-item:nth-last-child(1),
.pass-flow-item:nth-last-child(1) {
  width: 10px;
}
.min_item{
  min-width: 500px;
}
</style>
